import React, {Component} from 'react';
import {connect} from 'react-redux';
import {AutoComplete} from 'antd';

/**
 * Supported options:
 * -
 **/
class BukkuAutoComplete extends Component {
    render() {
        const {
            inputRef,
            popupContainerId,
            dispatch,
            ...restProps
        } = this.props;

        return <AutoComplete
            dropdownMatchSelectWidth={false}
            ref={inputRef}
            {...restProps}
        />;
    }
}
export default connect()(BukkuAutoComplete);
